namespace My {
    export class FastLinkVerificationModel extends ViewModel {
        constructor(input: JQuery, namePrefix?: string, container?: IBaseForm) {
            super(input, namePrefix, container);
        }
    }
}